import { get } from 'svelte/store';
import { format } from 'svelte-i18n';
//Types
import type { LabelProps } from '@Shelly/shelly-design-system/index';
import type { ActionJob } from 'src/types/requests/schedules/schedules_g2';

export const buildCameraLabels = (
	method: string,
	job: ActionJob,
	labelList: LabelProps[],
): LabelProps[] => {
	if (method === 'camera.setconfig') {
		const $format = get(format);
		if (job.params?.config?.arm != null) {
			labelList.push({
				value: job.params.config.arm
					? $format('camera_motion_detection_armed', { default: 'Armed' })
					: $format('camera_motion_detection_disarmed', { default: 'Disarmed' }),
				icon: job.params.config.arm ? 'fas fa-shield' : 'fas fa-shield-halved',
			});
		}
		if (job.params?.config?.privacy != null) {
			labelList.push({
				value: job.params.config.privacy
					? $format('camera_privacy_mode_on', { default: 'Privacy On' })
					: $format('camera_privacy_mode_off', { default: 'Privacy Off' }),
				icon: job.params.config.privacy ? 'fas fa-video-slash' : 'fas fa-video',
			});
		}
	} else {
		labelList.push({
			value: stringifyCameraAction(method),
			icon: getLocalActionIcons(method),
		});
	}
	if (method === 'camera.startrecording' && job.params?.duration != null) {
		labelList.push({
			value: `${job.params.duration}s`,
			icon: 'fas fa-timer',
		});
	}
	return labelList;
};

export const stringifyCameraAction = (method: string, action?: ActionJob): string => {
	const $format = get(format);
	let actionStringify = '';
	if (method === 'camera.captureimage') {
		actionStringify = $format('local_action_camera_capture_image', { default: 'Capture Image' });
	} else if (method === 'camera.startrecording') {
		actionStringify = $format('local_action_camera_start_recording', { default: 'Start Recording' });
		if (action?.params?.duration != null) {
			actionStringify += ` ${$format('text_trv_setting_duration', {
				default: 'Duration',
			})}: ${action.params.duration} ${$format('timer_text_sec', { default: 'sec' })}.`;
		}
	} else if (method === 'camera.setconfig') {
		actionStringify = $format('local_action_camera_configure', { default: 'Configure Camera' });
		if (action?.params?.config) {
			const config = action.params.config;
			if (config.arm != null) {
				actionStringify += ` ${$format('local_action_camera_motion_detection', {
					default: 'Motion Detection',
				})}: ${
					config.arm
						? $format('camera_motion_detection_armed', { default: 'Armed' })
						: $format('camera_motion_detection_disarmed', { default: 'Disarmed' })
				}`;
			}
			if (config.privacy != null) {
				actionStringify += ` ${$format('camera_privacy_mode', {
					default: 'Privacy Mode',
				})}: ${
					config.privacy
						? $format('on_action', { default: 'on' })
						: $format('off_action', { default: 'off' })
				}`;
			}
		}
	}
	return actionStringify;
};

const getLocalActionIcons = (method: string): string => {
	return method === 'camera.startrecording' ? 'fas fa-video' : 'fas fa-camera';
};
